import { render, staticRenderFns } from "./ArticlesListComponent.vue?vue&type=template&id=603fbc79&"
import script from "./ArticlesListComponent.vue?vue&type=script&lang=js&"
export * from "./ArticlesListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports